<template>
    <div>
        <!-- Modal -->
        <div class="modal fade" id="audioTranscriptionModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
            <div class="modal-dialog modal-dialog-total modal-dialog-scrollable" role="document">
                <div class="modal-content modal-content-total" v-if="instaciavel">
                    <div class="modal-header">
                        <h5 class="modal-title">Assistente IA: Transcrição</h5>
                        <button type="button" class="close" @click="fechar_modal()" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">

                        <template v-if="!token">
                            <az-empty-state 
                                msg="Aguardando Token de Acesso"
                                icon="fa-solid fa-microchip-ai" />
                        </template>

                        <template v-else>
                            <audio-transcription-recorder 
                                ref="atr" 
                                apiBaseUrl="http://127.0.0.1:8020"
                                :initial-recording-token="token"
                                :atendimento="atendimento" />
                        </template>

                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import _ from 'lodash';
import $ from 'jquery'; 
import AudioTranscriptionRecorder from './AudioTranscriptionRecorder.vue'
import AzEmptyState from '../../util/AzEmptyState.vue';

export default {
    data() {
        return { 
            instaciavel: false, 
            token: "", 
            info: null, 
        }
    },

    props: [
        'atendimento'
    ],

    components: {
        AudioTranscriptionRecorder,
        AzEmptyState,
    },
    
    methods: { 
        fechar_modal () { 
            $('#audioTranscriptionModal').modal('hide'); 

            this.token = null; 
            
            this.$nextTick(() => { 
                this.instaciavel = false; 
            });
        },

        abrir () { 
            this.instaciavel = true; 

            $('#audioTranscriptionModal').modal('show'); 

            if ( !this.token ) { 

                if ( !this.atendimento || !this.atendimento.id_atendimento ) 
                    return;

                this.$util.load(this, { 
                    service: 'iapep',
                    func: 'iniciar',
                    parms: { 
                        external_reference: 'atend-' + this.atendimento.id_atendimento, 
                        callback_url: 'https://webhook.site/c273438c-7cf8-4be1-ac4c-838966113b5c',
                    }, 
                    loadTo: res => { 
                        this.info = res; 
                        this.token = _.get(res, 'one_time_token');

                        console.log(res);
                    }
                });

            }

        }

    },

}
</script>

<style scoped>
.modal-dialog-total {
  top: 0;
  width: 100% !important;
  height: 100% !important;
  padding: 0 !important;
  max-width: 100% !important;
  max-height: 100% !important;
  margin-top: 0px;
  margin-bottom: 0px;
  margin: 0px !important;
}

.modal-content-total {
  height: 100% !important;
  max-height: 100% !important;
}

.modal-dialog2 {
  width: 98% !important;
  padding: 0 !important;
  max-width: 100%;
}

.modal-dialog3 {
  width: 100% !important;
  height: 100% !important;
  padding: 0 !important;
  max-width: 100%;
  max-height: 100% !important;
}
</style>
